import React from 'react';

export default function Seo({title}) {
    return <>
        <title id="pageTitle">{`Nanopore store: ${title}`}</title>
        <meta property="og:title" content={`Nanopore store: ${title}`}/>
    </>
}
